export default __webpack_public_path__ + "media/arrow-ios-right.2a486936.svg";